export class Role {
    public id: number;
    public description: string;
    public name: string;
    public role_id: number;

    constructor(
        id: number, 
        description: string,
        name: string,
        role_id: number
    ) {
        this.id = id;
        this.description = description;
        this.name = name;
        this.role_id = role_id;
    }
}